var getFileExtension = function getFileExtension(filename) {
  var filenameArray = filename.split('.');
  return filenameArray[filenameArray.length - 1].toLowerCase();
};
export default getFileExtension;